import React from "react";
import { Link } from "react-router-dom";

//material UI
import { Grid, Typography } from "@mui/material";

//imagens
import MyGenderLogo from "../../images/mygender-logo__small.svg";

//componentes
import CustomButton from "../../components/Button";

export default function AboutScreen() {
  return (
    <Grid container spacing={2} sx={{ minHeight: "100vh" }}>
      <Grid item xs></Grid>
      <Grid item xs={10} zeroMinWidth>
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: {
              xs: "5%",
              sm: "5%",
              md: "5%",
              lg: "0",
              xl: "0",
            },
          }}
        >
          <Grid item xs={12} sx={{ textAlign: "right", marginTop: "6vh" }}>
            <img
              src={MyGenderLogo}
              className="mygender-logo__about"
              alt="Logo oficial do projeto de investigação MyGender da Universidade de Coimbra"
            ></img>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ textAlign: "center" }}
            style={{ paddingLeft: "0" }}
          >
            <Typography
              color={"#000000"}
              letterSpacing={0}
              fontSize={{
                xs: "2rem",
                sm: "2rem",
                md: "2rem",
                lg: "3rem",
                xl: "3rem",
              }}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              textAlign={"center"}
            >
              Descobre o projeto
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color={"#000000"}
              letterSpacing={0}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, sans-serif"}
              lineHeight={{
                xs: "1.5rem",
                sm: "1.5rem",
                md: "1.5rem",
                lg: "2.5rem",
                xl: "2.5rem",
              }}
            >
              MyGender é o primeiro estudo em Portugal a investigar como os
              jovens adultos se envolvem com a tecnicidade e os imaginários das
              aplicações móveis, incorporando-os nas suas práticas do dia-a-dia
              e (re)negociando a partir deles as suas identidades sexuais e de
              género.
              <br />
              <br /> Desafiando a investigação centrada ou nos riscos e
              oportunidades ou nos usos e gratificações das práticas digitais,
              MyGender partirá de um entendimento da tecnologia como produtora
              de significados, subjetividade e agência, modelados por relações
              de poder. <br />
              <br />
              Adotando uma perspetiva crítica dos média digitais contemporâneos,
              o projeto analisará affordances, gramáticas, políticas das
              plataformas e conteúdos, assim como usos, apropriações e
              incorporações, para entender como influenciam a normatividade
              hegemónica e alteram a vida de jovens adultos.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              textAlign: "center",
              marginTop: "3vh",
              marginBottom: "15vh",
            }}
            style={{ paddingLeft: "0" }}
          >
            <Link to={"https://mygender.uc.pt/pt_PT/"}>
              <CustomButton
                type={"Link"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                backcolor={"#EDE838"}
                marginRight={"10px"}
                desc={"Visite o website oficial do projeto MyGender da UC"}
              ></CustomButton>
            </Link>
            <Link to={"https://www.instagram.com/mygender_"}>
              <CustomButton
                type={"Instagram"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                backcolor={"#EDE838"}
                marginRight={"10px"}
                desc={
                  "Visite a página oficial do projeto MyGender no Instragram"
                }
              ></CustomButton>
            </Link>
            <Link to={"https://www.facebook.com/mygender"}>
              <CustomButton
                type={"Facebook"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                backcolor={"#EDE838"}
                marginRight={"10px"}
                desc={"Visite a página oficial do projeto MyGender no Facebook"}
              ></CustomButton>
            </Link>
            <Link to={"https://twitter.com/mygender_"}>
              <img
                src={process.env.PUBLIC_URL + "/images/twitter-x.svg"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                alt="Visite o perfil oficial do projeto MyGender no X (ex Twitter)"
                style={{
                  boxSizing: "border-box",
                  verticalAlign: "middle",
                  backgroundColor: "#EDE837",
                  color: "#000000",
                  border: "5px solid #000000",
                  borderRadius: "57px",
                  borderWidth: "thick",
                }}
              ></img>
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
